<mat-form-field floatLabel="never" [ngClass]="classField()">
  <mat-select placeholder="..." [formControl]="control()">
    <mat-option [value]="null">
      <span translate>Empty</span>
    </mat-option>
    <mat-option [value]="'A4Plus'">A++++</mat-option>
    <mat-option [value]="'A3Plus'">A+++</mat-option>
    <mat-option [value]="'A2Plus'">A++</mat-option>
    <mat-option [value]="'A1Plus'">A+</mat-option>
    <mat-option [value]="'A'">A</mat-option>
    <mat-option [value]="'B'">B</mat-option>
    <mat-option [value]="'C'">C</mat-option>
    <mat-option [value]="'D'">D</mat-option>
    <mat-option [value]="'E'">E</mat-option>
    <mat-option [value]="'F'">F</mat-option>
    <mat-option [value]="'G'">G</mat-option>
  </mat-select>
</mat-form-field>